import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import {deviceMax, deviceMin} from '../../theme/breakpoints'
import {NAVBAR_HEIGHT} from '../../theme/constants'

import DesktopLogo from '../../images/logo/logo-constellium.svg'
import MobileLogo from '../../images/logo/logo-mobile.svg'

export const StyledDesktopLogo = styled(DesktopLogo)`
  display: flex;
  @media ${deviceMax.mobileL} {
    display: none;
  }
`

export const StyledMobileLogo = styled(MobileLogo)`
  display: none;
  @media ${deviceMax.mobileL} {
    display: flex;
    padding: 0 !important;
    height: ${pxToRem(NAVBAR_HEIGHT.mobile)} !important;
  }
`

export const StyledLogoContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  height: ${pxToRem(NAVBAR_HEIGHT.desktop)};
  background-color: white;
  @media ${deviceMin.laptop} {
    width: ${pxToRem(166)};
  }
  @media ${deviceMin.laptopL} {
    width: ${pxToRem(270)};
    padding: ${pxToRem(8)} ${pxToRem(30)} ${pxToRem(16)} ${pxToRem(20)};
  }

  @media ${deviceMax.tablet} {
    height: ${pxToRem(NAVBAR_HEIGHT.mobile)};
    padding: ${pxToRem(8)} ${pxToRem(14)} ${pxToRem(13)} ${pxToRem(10)};
  }
  @media ${deviceMax.mobileL} {
    background-color: initial;
    width: ${pxToRem(117)};
    padding: 0 0 0 ${pxToRem(11)};
  }
`
